import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fyt-admin-notify',
  templateUrl: './admin-notify.component.html',
  styleUrls: ['./admin-notify.component.css']
})
export class AdminNotifyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
